import React, { PureComponent, PropTypes } from 'react';

export default class SuperAdminFeature extends PureComponent {
  static contextTypes = {
    model: PropTypes.object.isRequired,
  };

  static propTypes = {
    alternate: PropTypes.node,
  };

  static defaultProps = {
    alternate: null,
  };

  static canAccess = (model) => model.isSuperAdmin();

  render() {
    if (SuperAdminFeature.canAccess(this.context.model)) {
      return React.Children.only(this.props.children);
    } else {
      return this.props.alternate;
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/common/access/SuperAdminFeature.jsx